import stockService from "@/services/stock/stock-service";

/** Total quantity on hand per inventory item; a failed lookup maps to null. */
export async function fetchStockTotals(inventoryIds: string[]): Promise<Record<string, number | null>> {
    const results = await Promise.allSettled(
        inventoryIds.map((id) => stockService.getWarehouseStockForInventory(id))
    );
    const totals: Record<string, number | null> = {};
    results.forEach((result, i) => {
        totals[inventoryIds[i]] = result.status === 'fulfilled'
            ? ((result.value ?? []) as any[]).reduce((sum: number, s: any) => sum + (s.QuantityOnHand ?? 0), 0)
            : null;
    });
    return totals;
}
